import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { AuthSheet } from '@/components/auth/AuthSheet';
import { goldGradientActive } from '@/lib/gradientStyles';
import { cn } from '@/lib/utils';

export function SignedOutInventory() {
  const [authOpen, setAuthOpen] = useState(false);

  return (
    <div className="flex-1 flex items-center justify-center px-6">
      <div className="max-w-sm w-full text-center space-y-6">
        <p className="text-white/80 leading-relaxed">
          Sign in to manage your inventory and list products for sale.
        </p>
        <Button
          onClick={() => setAuthOpen(true)}
          className={cn('h-12 w-full', goldGradientActive)}
        >
          Sign in / Create account
        </Button>
      </div>
      <AuthSheet open={authOpen} onOpenChange={setAuthOpen} />
    </div>
  );
}
